import React from 'react';

import { Typography as AntdTypo } from 'antd';

import { FilterButton, SearchBar } from 'components/WrappedComponents';

import {
  DashboardConfigurationFilter,
  DashboardConfigurationFilterFormValues,
} from '../../types';

import ConfigurationAdminFonctionnelFilterForm from './ConfigurationAdminFonctionnelFilterForm/ConfigurationAdminFonctionnelFilterForm';

import 'styles/DashboardHeaderFilter.less';

interface FiltersProps {
  filter: Partial<DashboardConfigurationFilter>;
  setFilter: (value: Partial<DashboardConfigurationFilter>) => void;
}

function Filters({ filter, setFilter }: FiltersProps): React.ReactElement {
  const { search, ...formFilter } = filter;

  function setFormFilter(
    value: Partial<DashboardConfigurationFilterFormValues>,
  ) {
    setFilter({
      ...filter,
      ...value,
    });
  }

  return (
    <div className="dashboard-header-filter">
      <SearchBar
        searchedStr={search}
        triggerSearch={value =>
          setFilter({ ...filter, search: value || undefined })
        }
        antdProps={{
          placeholder: 'Recherche dans le nom ou la description…',
          style: { maxWidth: 300 },
        }}
        rounded={true}
      />

      <FilterButton
        filter={formFilter}
        setFilter={setFormFilter}
        textInactiveFilter="Filtres"
        textActiveFilter="Filtres (actifs)"
      >
        {(setData, data) => (
          <>
            <AntdTypo.Title level={3}>Filtres</AntdTypo.Title>
            <ConfigurationAdminFonctionnelFilterForm
              filter={data}
              setFilter={setData}
            />
          </>
        )}
      </FilterButton>
    </div>
  );
}

export default Filters;
